import { render, staticRenderFns } from "./tuiyijunren_tyjryb.vue?vue&type=template&id=ac2395bc"
import script from "./tuiyijunren_tyjryb.vue?vue&type=script&lang=js"
export * from "./tuiyijunren_tyjryb.vue?vue&type=script&lang=js"
import style0 from "./tuiyijunren_tyjryb.vue?vue&type=style&index=0&id=ac2395bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports